module.exports = __webpack_public_path__ + "static/img/fr.a8c0c859.png";